<template lang="pug">
.order-admin-chat
  div
    .order-activity__title {{$t('Components.Orders.OrderAdminChat.comments')}}
    .columns.is-mobile.is-centered.order-activity__tabs
      .column.is-narrow.is-paddingless.order-activity__tab(@click="displayComments()" :class="{ 'order-activity__tab--active': showComments }")
        img(src="@/assets/img/orders/comment-icon.svg")
      .column
      .column
    v-app(id="inspire",v-if="noteList && noteList.length !== 0")
      admin-note-item(v-for='item in noteList', :key="item.createdAt"
        :note="item"
        :brand="brand"
        :retailer="retailer" @parent-on-note-deleted="childNoteDeleted")
    .order-activity__comment-input-group
      input.input.order-activity__comment-input(
        placeholder="Add note..." v-model.trim="newCommentText"
        @keyup.enter="addComment()"
      )
      a.button.order-activity__coment-input-button(
        v-if="!isShow"
        @click="addComment()"
        :style="{background: buttonColor}"
      ) {{$t('Components.Orders.OrderAdminChat.sendBtn')}}
</template>

<script>
import AdminNotesService from "@/services/admin-notes-service"
import AdminNoteItem from "@/components/common/AdminNoteItem"
import constants from "@/config"





export default {
  components: {
    "admin-note-item": AdminNoteItem
  },
  props: {
    brand: { type: Object, default: () => {} },
    // comment: { type: Object, default: () => {} },
    retailer: { type: Object, default: () => {} },
    order: { type: Object, default: () => {} },
    buttonColor: { type: String, default: () => "" },
    isShow: { type: Boolean, default: false }
  },
  data() {
    return {
      showComments: true,
      showTimeline: true,
      newCommentText: "",
      alignTop: false,
      avatar: false,
      dense: true,
      fillDot: false,
      hideDot: false,
      icon: false,
      iconColor: false,
      left: false,
      reverse: false,
      right: true,
      small: false,
      // comment: {},
      loading: false,
      massageList: [],
      noteList: []
    }
  },
  computed: {
    userId() {
      return this.$store.getters["user/id"]
    },
    role() {
      return this.$store.getters["user/role"]
    },
    isRetailer() {
      return this.role === "retailer" || constants.adminRetailerRoutes.includes(this.$route.name)
    },
    isBrand() {
      return this.role === "brand" || constants.adminBrandRoutes.includes(this.$route.name)
    },
    comment() {
      return this.$store.getters["adminMessage/searchMessage"]
    }
  },
  // watch: {
  //   comment(a, b) {
  //     console.log(44444, a, b)
  //   }
  // },
  async mounted() {
    // this.comment = {}
    // const params = {
    //   itemize: "send",
    //   _limit: 50,
    //   _index: 1,
    //   "order-id": this.$route.params.id
    //   // "client-id": this.brand.id,
    //   // "message-type-id": "Order",
    //   // category: "Orders"
    // }
    // // const textObj = `Landing Reference ID: ${this.order.landingReferenceId}`
    // this.comment = await this.$store.dispatch("adminMessage/fetchSearchMessage", { params })
    this.getOrderMessageDetails()
    // this.comment = {
    //   ...list
    //   // messages: list.messages.filter(item => item.subject === textObj)
    // }
  },
  methods: {
    childNoteDeleted(noteId) {
      console.log('childNoteDeleted', noteId)
       AdminNotesService.deleteChat(noteId).then(res => {
        this.noteList = res
        console.log('POST delete response', res);
        this.newCommentText = ""
        this.getOrderMessageDetails()
      })
    },
    addComment() {
      if (!this.newCommentText) {
        return
      }
      let orderId = this.order.id //4169
      let emailAddress = this.$store.getters["user/email"]
      let userId = this.userId

      AdminNotesService.postChat(orderId, this.newCommentText, emailAddress, userId).then(res => {
        this.noteList = res
        console.log('POST response', res);
        this.newCommentText = ""
        this.getOrderMessageDetails()
      })

    },
    getOrderMessageDetails() {
      let orderId = this.order.id //4169
      console.log('GET Notes', this.order.id);
      AdminNotesService.getChats(orderId).then(res => {
        if (res && res.length > 0) {
          this.noteList = res
          console.log(res);
        }
      })
    }
  }
}
</script>

<style lang="sass">
.v-avatar
  background: white !important
  border-radius: 10%
.order-activity
  padding-top: 40px

  &__logo
    width: 36px
    height: auto

  &__tabs
    padding-bottom: 54px
    padding-top: 0
    border-top: 1px solid #DFE3E8
    height: 18px
    box-sizing: border-box

  &__tab
    cursor: pointer
    width: 30px
    height: 26px
    text-align: center
    margin-right: 5px

  &__tab--active
    border-top: 2px solid black

  &__time-tab
    position: absolute
    left: 35px
    padding-right: 8px
    padding-left: 8px
    cursor: pointer

  &__title
    font-size: 16px
    color: #212B36
    padding-bottom: 20px
    padding-left: 20px

  &__timeline-container
    border-left: 2px solid #DFE3E8
    margin-left: 20px

  &__timeline-logo-icon
    margin-left: -16px
    padding: 1px
    border: 1px solid #aaaaaa
    height: 37px
    width: 37px
    background: white

  &__timeline-clock-icon
    margin-left: -9px
    z-index: 999
    img
      background: white

  &__account-name
    margin-left: 10px
    color: #4A90E2
    font-size: 14px
    font-weight: bold

  &__date
    margin-left: 10px
    color: #AAAAAA
    font-size: 14px
    font-weight: 500
    text-transform: lowercase

  &__comment
    margin-left: 10px
    font-size: 14px
    color: #333333

  &__comment-input-group
    margin-top: 20px
    position: relative
    margin-bottom: 20px

  &__comment-input
    height: 44px
    font-size: 16px

  &__comment-input::placeholder
    font-size: 16px !important

  &__coment-input-button
    width: 89px
    position: absolute
    right: 10px
    top: 70px
    //margin-left: -60px
    margin-top: 5px
    color: #ffffff
    border: none
    font-size: 15px
    border-radius: 2px

  &__event:last-child
    background: white
    height: 100%

.order-activity__timeline-container
  .time-line__wrap
    height: 100%
    margin-top: 0px
    display: flex

    .time-line-list
      margin: 0
      padding: 0
      list-style: none
      width: 100%
      position: relative
      overflow: auto
      display: flex
      flex-direction: column

      .time-line
        position: relative

      .time-line:after
        display: inline-block
        width: 2px
        height: 100%
        background-color: #D7D9DE
        position: absolute
        top: 27px
        left: 17px
        z-index: 1

        .img-block
          position: absolute
          top: 0
          left: 0

        .order-activity__block
          padding: 14px 0px 11px 36px
.commentDate
  color: #AAAAAA
  font-size: 14px
  margin-right: 6px
.v-application--wrap
  max-height: 500px
  overflow-y: auto;
  display: flex
  flex-direction: column-reverse !important
.order-admin-chat
  margin-top: 1.5em;
  border: 1px solid #dce0e4
  padding: 4em
</style>
